import './App.scss';
import Header from '../Tools/Header/Header';
import Footer from '../Tools/Footer/Footer';
import Menu from '../Tools/Menu/Menu';
import Notification from '../Tools/Notification/Notification';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Main from './Main';
import axios from 'axios';

function App() {
  const [showMenu, setShowMenu] = useState(false)
  const location = useLocation()

  const [BestOnline, setBestOnline] = useState([
    // LuckyStake
    {
      "Active": true,
      "Provider": "LuckyStake",
      "Logo": require(`../Images/LuckyStake_Logo.png`),
            "Attributes": [
        {
          "attribute": "GenesisStake welcome offer: Up to 1.2M Gold Coins and 25 SC Coins + Free Spins + 20 SC + Claim 20,000 GC + 2 SC – No Purchase Required"
        },
        {
          "attribute": "Over 500+ games including slots and Social-Style Slots & Card Games, Enjoy a Wide Variety of Sweepstakes-Style Games"
        },
        {
          "attribute": "Available in 44 U.S. states – play with free virtual currencies and Collect Free Coins Every Day"
        }
      ],
 
      "Score": {
        "TitleDemand": "Most Winnable Sweepstakes",
        "TitleSecDemand": "Top Rated. Trusted for Fun & Entertainment.",
        "Rating": "EXCELLENT",
        "RatingCount": 10,
        "TimesVoted": 15240,
        "Review": "LuckyStake offers an incredible variety of fun, free-to-play games. Smooth experience, great community, and exciting daily rewards keep me coming back every day!"
      },
      "Promostion": "Up to 1.2M Gold Coins and 25 SC on registration & 150% Extra: 50K GC + 25 SC",
      // "AffiliateLink": "https://lucky-stake.com/api/v3/offer/50?affiliate_id=125&url_id=120",
      "AffiliateLink": "https://lucky-stake.com/api/v3/offer/50?affiliate_id=125&url_id=119",
      "Requirements": "18+ New Players Only. T&C Apply"
    },
    // SweepNext
    {
      "Active": true,
      "Provider": "SweepNext",
      "Logo": require(`../Images/SweepNext_Logo.png`),
     "Attributes": [
        {
          "attribute": "Over 1,000 free-to-play - style games available instantly"
        },
        {
          "attribute": "No download required – play directly in your browser or on mobile"
        },
        {
          "attribute": "Join thousands of players and enjoy daily rewards and tournaments"
        }
      ],
      "Score": {
        "TitleDemand": "More Chances, More Wins",
        "TitleSecDemand": "Trusted Sweepstakes Platform",
        "Rating": "VERY GOOD",
        "RatingCount": 9.9,
        "TimesVoted": 8975,
        "Review": "SweepNext delivers a fun sweepstakes experience with a wide selection of slots and live dealer games. Easy signup, daily rewards, and a smooth website design make it a solid choice for social  fans."
      },
      "Promostion": "Up to 600K Gold Coins + Free Spins + 20 SC",
      "AffiliateLink": "https://aff.iexc.io/visit/?bta=35210&brand=sweepsnext",
      "Requirements": "21+ New Players Only. T&C Apply"
    },

  ]);

  useEffect(() => {

  }, []);

  return (
    <div className="App" style={false ? { "document.html.style.overflow": "hidden" } : null}>
      {/* Menu */}
      {showMenu ? <Menu setShowMenu={setShowMenu} /> : null}
      {/* Header */}
      {/* {location.pathname.match("/request-service") ? null : <Header showMenu={showMenu} setShowMenu={setShowMenu} />} */}
      {/* Main App */}
      <Main BestOnline={BestOnline} />
      {/* Footer */}
      {/* {location.pathname.match("/request-service") ? null : <Footer Companies={Companies} WebSitePages={WebSitePages} />} */}

    </div>
  );
}

export default App;
